import qs from "qs";
import { VB_URL_PARAMS, VIRTUAL_BORE_EVENTS } from "./constants";

/**
 * Programmatically trigger the Virtual Bore tool with specific coordinates
 * This sets the URL parameters which will cause the VirtualBore dialog to open
 *
 * @param {number} lat - Latitude coordinate
 * @param {number} lon - Longitude coordinate
 */
export const triggerVirtualBore = (lat, lon) => {
  if (!lat || !lon || isNaN(lat) || isNaN(lon)) {
    return;
  }

  // Get current URL parameters
  const currentParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  // Set virtual bore parameters
  currentParams[VB_URL_PARAMS.LAT] = lat.toString();
  currentParams[VB_URL_PARAMS.LON] = lon.toString();

  // Update URL with new parameters
  const newSearch = qs.stringify(currentParams, { addQueryPrefix: true });
  window.history.pushState({}, "", `${window.location.pathname}${newSearch}`);

  // Dispatch event to notify virtual bore listeners
  window.dispatchEvent(new CustomEvent(VIRTUAL_BORE_EVENTS.URL_PARAMS_CHANGED));
};
